import React from "react";
import { motion, useScroll, useTransform } from "framer-motion";

/**
 * CinematicVignette — global atmosphere overlay, sits above content but below text.
 * - Subtle radial darkening at the edges (vignette)
 * - Faint scanline / film grain texture
 * - Top + bottom fade gradient that intensifies on scroll
 *
 * Non-interactive. Drop once at the page root.
 */
export const CinematicVignette = () => {
    const { scrollYProgress } = useScroll();
    const intensity = useTransform(scrollYProgress, [0, 0.5, 1], [0.85, 1, 0.9]);

    return (
        <motion.div
            aria-hidden="true"
            className="pointer-events-none fixed inset-0 z-[5]"
            style={{ opacity: intensity }}
        >
            {/* Edge vignette */}
            <div
                className="absolute inset-0"
                style={{
                    background:
                        "radial-gradient(ellipse 90% 90% at 50% 50%, transparent 40%, rgba(0,0,0,0.55) 95%)",
                }}
            />
            {/* Top/bottom cinematic bands */}
            <div className="absolute inset-x-0 top-0 h-32 bg-gradient-to-b from-black/60 to-transparent" />
            <div className="absolute inset-x-0 bottom-0 h-32 bg-gradient-to-t from-black/40 to-transparent" />
            {/* Film grain */}
            <div
                className="absolute inset-0 mix-blend-overlay opacity-[0.06]"
                style={{
                    backgroundImage:
                        "url(\"data:image/svg+xml,%3Csvg viewBox='0 0 240 240' xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='n'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.92' numOctaves='2' stitchTiles='stitch'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23n)' opacity='0.9'/%3E%3C/svg%3E\")",
                }}
            />
        </motion.div>
    );
};

export default CinematicVignette;
